export interface SubsidyBreakdownInput {
  financeAmount: number;
  dnet: number;
  subsidyPercent: number;
  dnetCoefficient: number;
  dealerParticipationPercent: number;
}

export interface SubsidyBreakdown {
  approvedSubsidyAmount: number;
  dealerContribution: number;
  oemContribution: number;
}

/**
 * Mirror of the backend calculation, used for real-time table preview only.
 * Source of truth is the API response after mutation.
 */
export const calculateSubsidyBreakdown = ({
  financeAmount,
  dnet,
  subsidyPercent,
  dnetCoefficient,
  dealerParticipationPercent,
}: SubsidyBreakdownInput): SubsidyBreakdown => {
  const subsidyRate = subsidyPercent / 100;
  const cap = dnet * dnetCoefficient;
  const approvedSubsidyAmount = subsidyRate * Math.min(financeAmount, cap);

  const dealerContribution = (financeAmount * dealerParticipationPercent) / 100;
  const oemContribution = Math.max(approvedSubsidyAmount - dealerContribution, 0);

  return { approvedSubsidyAmount, dealerContribution, oemContribution };
};
